<div class="confirm-status-dialog-wrapper">
    <h1 mat-dialog-title>{{ data.title }}</h1>
    <mat-dialog-content>
        <div class="warn-box">
            <mat-icon class="warn-icon">warning</mat-icon>
            <span class="warn-msg"><b>Dieser Schritt kann nicht rückgängig gemacht werden.</b></span>
        </div>
        <p class="dialog-message">{{ data.message }}</p>
        @if (data.targetStatus) {
            <div class="target-status-row">
                <span class="target-label">Zielstatus:</span>
                <mat-chip highlighted>{{ data.targetStatus }}</mat-chip>
            </div>
        }
    </mat-dialog-content>
    <mat-dialog-actions>
        <button matButton="outlined" (click)="confirm()">Bestätigen</button>
        <button matButton="outlined" (click)="cancel()">Abbrechen</button>
    </mat-dialog-actions>
</div>

